import { includes } from 'lodash';
import quoteTypes from 'commons-vehicle/Quote/actions/quoteActionTypes.js';
import purchaseMethodsTypesV25 from 'commons-vehicle/PurchaseMethodsV25/actions/purchaseMethodsActionTypesV25.js';
import QuoteModelV25 from 'commons-vehicle/Quote/models/QuoteModelV25.js';

export default function quoteReducer(state = new QuoteModelV25(), action) {
    switch (action.type) {
        case quoteTypes.SET_QUOTEV25:
            return action.quote.set('loading', false).set('error', '');

        case quoteTypes.SET_QUOTE_VEHICLE:
            return state.set('vehicle', action.vehicle);

        case quoteTypes.SET_LOADING:
            return state.set('loading', action.loading);

        case quoteTypes.SET_ERROR:
            return state.set('error', action.error).set('loading', false);

        case purchaseMethodsTypesV25.LOAD_PURCHASE_METHODS_SUCCESSV25:
            return state.setIn(['vehicle', 'purchaseMethods'], action.purchaseMethodsV25).set('modified', true);

        default:
            if (includes(purchaseMethodsTypesV25.QUOTE_UPDATE_TYPES, action.type)) {
                return state.set('modified', true);
            }
            return state;
    }
}
